import { render, staticRenderFns } from "./ContentTypes.vue?vue&type=template&id=9c55c744&"
import script from "./ContentTypes.vue?vue&type=script&lang=ts&"
export * from "./ContentTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports